import React from 'react';
import { FsSelect, FsOption } from '@finalsite/wc-react';
import { getHtmlId, getHtmlName } from '../utils/CustomFieldHelpers';

export const SingleSelectField = ({ field, name, id, onChange, getFieldValue}) => {
  const value = getFieldValue(field.mapped_name);

  return <FsSelect id={id}
                   name={name}
                   label={field.rendered_prompt}
                   required={field.required_on_form || field.has_required_children}
                   hint={field.rendered_explanation}
                   {...{onChange}}
  >
    {field.options?.map((option, index) => (
      <FsOption key={option + index} value={option || ''} selected={value === option}>
        {option}
      </FsOption>
    ))}
  </FsSelect>;
}
